import React, { useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import PortalButton from './PortalButton';
export default function ConfirmButton({ message, onConfirm, children, ...props }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <PortalButton {...props} onClick={() => setOpen(true)}>
        {children}
      </PortalButton>
      <SweetAlert
        warning
        show={open}
        title="Confirmar exclusão"
        onConfirm={() => {
          setOpen(false);
          onConfirm();
        }}
        onCancel={() => setOpen(false)}
        showCancel
        confirmBtnText="Sim, excluir"
        cancelBtnText="Cancelar"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
      >
        {message}
      </SweetAlert>
    </>
  );
}
